export const DASHBOARD_REFETCH_INTERVAL_MS = 120 * 1000;
